import React, { useState, useEffect } from 'react';
import { Box, Heading, Flex, Text } from 'rebass';
import { v4 } from 'uuid';
import store from 'store';
// import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
// import { VoiceRecorder } from "react-voice-recorder-player";
import Modal from 'app/modal/v3';
import { useStopwatch } from 'react-timer-hook';
import { FiSettings } from 'react-icons/fi';
import ActionItems from './ActionItems';
import { HiOutlineMicrophone } from "react-icons/hi2";
import AudioPlayer from './AudioPlayer';
import RecordButton from 'chats/RecordButton';
import { ControlButtons } from 'chats/VideoPreview';
import { Label } from 'story-media/new/styled';
import ButtonLabelWrap from 'story-media/new/button-label-wrap';
import ReactAudioPlayer from './ReactAudioPlayer';
import MicRecorder from 'mic-recorder-to-mp3';
import { checkIsIpadUser, useCheckIsIosUser, useIsSafariUser } from 'story-media/hooks';
import Timer from 'chats/Timer';
import { Duration } from 'chats/RecordVideo';
import { keyframes } from '@emotion/react';

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    color: #9B59B6;
  }
  25% {
    transform: scale(1.1);
    color: #9B59B6;
  }
  50% {
    transform: scale(1.2);
    color: #9B59B6;
  }
  75% {
    transform: scale(1.1);
    color: #9B59B6;
  }
  100% {
    transform: scale(1);
    color: #9B59B6;
  }
`;


function RecordAudio({ onSubmitMedia, question, isSelected, onClick = () => { }, label = "Respond with audio", justIcon = false }) {
    const [startRecording, setStartRecording] = useState(false);
    const [isRecording, setIsRecording] = useState(null);
    const [recorder, setRecorder] = useState(null);

    const [file, setFile] = useState(null);
    const [url, setUrl] = useState(null);
    const [isDisabled, setIsMicrophoneDisabled] = useState(false);
    const [openSettingsModal, setOpenSettingsModal] = useState(false);

    const [isPlaying, setIsPlaying] = useState(false)
    const [showTimer, setShowTimer] = useState(false);
    const [audioTime, setAudioTime] = useState(null);
    const [loading, setLoading] = useState(true);
    const [audioDeviceId, setAudioDeviceId] = useState(null);
    const [audioDevices, setAudioDevices] = useState([]);

    const isSafariUser = useIsSafariUser();
    const iOSUser = useCheckIsIosUser()
    const isIpadUser = checkIsIpadUser();
    const isIOSUser = iOSUser || isIpadUser;

    useEffect(() => {
        const recorder = new MicRecorder({
            bitRate: 128
        });
        setRecorder(recorder)
    }, [])
    // const recorderControls = useAudioRecorder()
    async function startAudioRecording() {
        await recorder.start()
    }

    function stopAudioRecording() {
        if (recorder && recorder?.stop) {
            try {
                recorder.stop()?.getMp3().then(([buffer, blob]) => {
                    const blobURL = URL.createObjectURL(blob);
                    blob.name = `${v4()}.${blob.type.split('/')[1]}`;
                    setFile(blob)
                    setUrl(blobURL)
                }).catch(err => console.log(err));
            }
            catch (err) {
                console.log(err)
            }
        }
    }

    useEffect(() => {
        if (isSafariUser || isIOSUser) {
            if (isRecording === true)
                startAudioRecording()
            else if (isRecording === false)
                stopAudioRecording()
        }
    }, [isRecording, isSafariUser, isIOSUser])

    const handleClick = async () => {
        setStartRecording(true)
        onClick()
        return
    };

    useEffect(() => {
        if (startRecording)
            navigator.mediaDevices
                .getUserMedia({ audio: true })
                .then(function (stream) {
                    console.log('Microphone access is allowed. ', stream);
                    stream.getAudioTracks().forEach((track) => {
                        track.stop();
                    });
                })
                .catch(function (err) {
                    if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                        console.log('Microphone access is denied.', err);
                        setIsMicrophoneDisabled(true);
                    } else {
                        console.error('Error accessing microphone:', err);
                    }
                });

    }, [startRecording])

    const {
        seconds,
        minutes,
        hours,
        start,
        pause,
        reset
    } = useStopwatch({ autoStart: false, offsetTimestamp: 0, onExpire: () => console.warn('onExpire called'), interval: 20 });

    useEffect(() => {
        if (isRecording)
            start()
        else if (isRecording === false) reset(0, 0)

    }, [isRecording])

    const onClose = () => {
        setFile(null)
        setUrl(null)
        setStartRecording(false)
        setIsRecording(false)
    }

    const closeStream = () => {
        if (window.localStream) {
            window.localStream.getAudioTracks().forEach((track) => {
                track.stop();
            });
        }
    };

    function SelectedMediaDeviceID(kind) {
        const tracks = window.localStream.getTracks();
        return tracks.filter((trac) => trac.kind === kind).map((trac) => trac.getSettings().deviceId);
    }

    const selectAudioDevice = async () => {
        const selectedAudioID = await SelectedMediaDeviceID('audio');
        setAudioDeviceId(selectedAudioID[0]);
        setLoading(false);
    };

    const handleDevices = (mediaDevices) => {
        const audioDevicesAttached = mediaDevices.filter(({ kind }) => kind === 'audioinput');
        if (
            audioDevicesAttached.length !== audioDevices.length ||
            audioDevicesAttached.filter((dev) => !!dev.label).length !==
            audioDevices.filter((dev) => !!dev.label).length
        ) {
            const selectedAudioID = SelectedMediaDeviceID('audio');
            if (audioDevicesAttached.length > 0) {
                if (store.get('selectedAudioDeviceID'))
                    setAudioDeviceId(store.get('selectedAudioDeviceID'));
                else setAudioDeviceId(selectedAudioID[0]);
            }
            setAudioDevices(
                audioDevicesAttached
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map((device) => {
                        const clonedDevice = device.toJSON();
                        const { label } = clonedDevice;
                        const haveParenthesisText = label.match(/\(([^)]+)\)/);
                        if (haveParenthesisText && haveParenthesisText.length > 1) {
                            const updatedString = haveParenthesisText[1];
                            clonedDevice.label = label.replace(`(${updatedString})`, '');
                        }
                        return clonedDevice;
                    })
            );
        }
    };

    const getAllMediaItems = () => {
        closeStream();
        navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
                window.localStream = stream;
                if (!navigator.mediaDevices?.enumerateDevices) {
                    selectAudioDevice();
                } else {
                    navigator.mediaDevices.enumerateDevices().then(handleDevices).catch(() => setIsMicrophoneDisabled(true));
                }
            })
            .catch((err) => {
                setIsMicrophoneDisabled(true)
            });
    };

    useEffect(() => {
        if (startRecording)
            getAllMediaItems();
        //setLoading(false);

        return async () => {
            closeStream();
        };
    }, [startRecording]);

    const handleChange = (e) => onSubmitMedia(e.target.files, true);

    const onStop = ({ blob, url, type }) => {
        if (!isSafariUser && !isIOSUser) {
            try {
                blob.name = `${v4()}.${type.split('/')[1]}`;
                setFile(blob)
                setUrl(url)
            }
            catch (err) {
            }
        }
    };

    if (audioDevices.length > 0 && audioDeviceId && loading) {
        setLoading(false);
    }
    return <>
        {startRecording && <Modal
            close={{ onClose }}
            maxWidth={800}
            title="Record your voice"
            closeOnOutsideClick={false}
            aboveTooltip
        >
            <Box sx={{ position: 'relative' }} onClick={() => openSettingsModal && setOpenSettingsModal(false)}>
                {isDisabled ? <Box className="disabledVideoContentContainer" textAlign="left" m={4}>
                    <Heading variant="headings.h1" color="#ED2300" fontSize={20}>
                        To record an audio, your browser needs access to your microphone.
                        <br />
                        <br />
                        Please refresh this page and grant permission. If that doesn&apos;t work, go to your
                        phone&apos;s browser settings to provide permission.
                    </Heading>
                </Box> : <Flex flexDirection="column" alignItems="center">
                    {showTimer && (
                        <Timer hideTimer={() => {
                            setShowTimer(false);
                            setIsRecording(!isRecording)
                        }} />
                    )}
                    {url &&
                        <AudioPlayer
                            audioTime={audioTime}
                            src={url}
                            isPlaying={isPlaying}
                            setIsPlaying={setIsPlaying}
                        />
                    }

                    {!isSafariUser && !isIOSUser && !url && <ReactAudioPlayer
                        deviceId={audioDeviceId}
                        isRecording={isRecording}
                        onStop={onStop}
                    />}
                    {(isSafariUser || isIOSUser) && !url && <Flex justifyContent="center" alignItems="center" bg="#F5EEF8" sx={{ borderRadius: '4px', width: '100%', height: 300 }}>
                        <Box as={HiOutlineMicrophone}
                            size={120}
                            color="#FFFFFF"
                            sx={isRecording && {
                                animation: `${pulseAnimation} 2s infinite`
                            }}
                        />
                    </Flex>}

                    {url ?
                        <ControlButtons
                            isPlaying={isPlaying}
                            handlePlayPause={() => setIsPlaying(!isPlaying)}
                            onReject={() => {
                                setIsPlaying(false)
                                setIsRecording(false)
                                setFile(null)
                                setUrl(null)
                            }}
                            rejectLabel="Re-record"
                            onAccept={() => {
                                const newFile = new File([file], file.name, { type: file.type, lastModified: Date.now() });
                                handleChange({ target: { files: [newFile] } })
                                onClose()
                            }}
                        />
                        :
                        <Flex p={3} width="100%" justifyContent="space-between">
                            {audioDevices.length > 1 && <>
                                <Flex
                                    height={40}
                                    alignItems="center"
                                    sx={{
                                        background: '#fff',
                                        cursor: 'pointer',
                                        opacity: loading && 50,
                                        borderRadius: '23px',
                                        border: '1.5px solid #9B59B6'
                                    }}
                                    p="10px 20px"
                                    onClick={() => !loading && setOpenSettingsModal(!openSettingsModal)}
                                >
                                    <FiSettings color="#9B59B6" size={16} />
                                    <Text sx={{ display: ['none', 'block'] }} ml={1} color="#9B59B6" fontFamily="Poppins" letterSpacing="-0.084px">
                                        Settings
                                    </Text>
                                </Flex>
                                <Box
                                    sx={{
                                        width: '300px',
                                        position: 'absolute',
                                        borderRadius: '31px',
                                        border: '1.5px solid #9B59B6',
                                        background: '#FFF',
                                        display: openSettingsModal ? 'block' : 'none',
                                        bottom: 5,
                                        zIndex: 1,
                                    }}
                                    pb={3}
                                >
                                    {audioDevices.length > 1 && (
                                        <>
                                            <Text p={2} fontFamily="Poppins" lineHeight="110%" fontWeight={400} color="codGrey">
                                                Microphone
                                            </Text>
                                            {audioDevices.map((device, key) => (
                                                <Flex
                                                    p={2}
                                                    key={device.deviceId}
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    bg={device.deviceId === audioDeviceId && '#F5EEF8'}
                                                    sx={{ cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setAudioDeviceId(device.deviceId);
                                                        store.set('selectedAudioDeviceID', device.deviceId);
                                                        setOpenSettingsModal(false);
                                                    }}
                                                >
                                                    <Text
                                                        fontFamily="Poppins"
                                                        lineHeight="110%"
                                                        fontWeight={400}
                                                        fontStyle="normal"
                                                        color="codGrey"
                                                        key={device.deviceId}
                                                        textAlign="center"
                                                    >
                                                        {device.label || `Device ${key + 1}`}
                                                    </Text>
                                                </Flex>
                                            ))}
                                        </>
                                    )}
                                </Box>
                            </>}
                            <Flex alignItems="center">
                                <div style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '50%',
                                }}
                                >
                                    <div
                                        style={{
                                            background: isRecording ? '#EE0000' : '#E0E0E0',
                                            height: '100%',
                                            width: '100%',
                                            borderRadius: '50%',
                                            transition: 'all .5s ease',
                                        }}
                                    />
                                </div>
                                {/* <Flex alignItems="center" ml={1} width={100} > */}
                                <Duration hours={hours} minutes={minutes} seconds={seconds} isCapturing={isRecording} />
                                {/* </Flex> */}
                            </Flex>
                            <Flex
                                justifyContent="center"
                                alignItems="flex-end"
                                sx={{
                                    width: 'max-content',
                                    opacity: showTimer ? 0 : 1,
                                }}
                            >
                                <RecordButton
                                    isRecording={isRecording}
                                    isDisabled={isDisabled}
                                    isIOSUser={isIOSUser}
                                    onClick={() => {
                                        if (isRecording) {
                                            setIsRecording(false);
                                        }
                                        if (!isRecording) {
                                            setShowTimer(true);
                                        }
                                    }}
                                />
                            </Flex>
                        </Flex>
                    }
                </Flex>}
            </Box>
        </Modal>
        }

        {justIcon ? <Box onClick={handleClick} >
            <ButtonLabelWrap label={label} >
                <Label>
                    <HiOutlineMicrophone />
                </Label>
            </ButtonLabelWrap>
        </Box>
            : <ActionItems
                onClick={handleClick}
                isSelected={isSelected}
                nextIcon={isSelected}
                icon={HiOutlineMicrophone}
                iconSize={24}
                label={label}
            />}
    </>
}

export default RecordAudio;